module.exports=function(scope){ return `var https = require("https");
data = JSON.stringify({
  "source": {"enrollmentIdentifier": INSERT_ENROLLMENT_IDENTIFIER_FOR_3D_FACEMAP_HERE},
  "target": {"image": INSERT_2D_FACEMAP_AS_BASE64_HERE}
})

callFaceTecAPI(data, "/match-3d-2d", function(error, result) {
  if(error) {
    console.log("Error:" + error);
  }
  else if(result) {
    console.log(result)
  }
})

function callFaceTecAPI(data, path, callback){
  var options = {
    hostname: "your.internal.zoomserver.instance.url",
    port: 443,
    path: path,
    method: "POST",
    headers: {
        "Content-Type": "application/json",
        "X-User-Agent": INSERT_X_USER_AGENT_VALUE_HERE
    }
  }

  var req = https.request(options, (res) => {
      var output = ""

      res.on("data", (d) => {
          output += d
      })

      res.on("end", () => {
        try{
					var obj = JSON.parse(output)
          callback(undefined, obj.data)
        }
        catch(error) {
          callback(error, undefined)
        }
      })
  })

  req.on("error", (error) => {
    callback(error, undefined)
  })

  req.write(data)
  req.end()
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/standard-server/nodejs/compare-3d-2d.js.tpl